import React, { useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Header from '../components/Header';
import ActionButtons from '../components/ActionButtons';
import { fields, LOCAL_STORAGE_KEY } from '../constants';
import { getDetailsApi } from '../utils/api';
import { mergeLookupDetails } from '../utils/lookupDetails';

const Mizoram = () => {
  const isLoggedIn = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY));
  const state = 'mizoram';
  const history = useHistory();

  const MIZO_FIELDS = {
    districtName: [
      { name: "VAIRENGTE" },
      { name: "KANHMUN" },
      { name: "ZOKHAWTHAR" },
      { name: "KAWRPUICHHUAH" },
    ],
    checkPostName: [
      { name: "VAIRENGTE CHECKGATE", district: "VAIRENGTE" },
      { name: "KANHMUN CHECKGATE", district: "KANHMUN" },
      { name: "ZOKHAWTHAR CHECKPOST", district: "ZOKHAWTHAR" },
      { name: "KAWRPUICHHUAH CHECKPOST", district: "KAWRPUICHHUAH" },
    ],
    vehiclePermitType: [
      { name: "TRANSPORT" },
    ],
    vehicleClass: [
      { name: "CAMPER VAN / TRAILER (PRIVATE USE)", type: "PASSENGER" },
      { name: "MOTOR CARAVAN", type: "PASSENGER" },
      { name: "MAXI CAB", type: "PASSENGER" },
      { name: "MOTOR CAB", type: "PASSENGER" },
      { name: "BUS", type: "PASSENGER" },
      { name: "GOODS CARRIER", type: "GOODS" },
      { name: "MULTI-AXLED GOODS", type: "GOODS" },
      { name: "TRACTOR (COMMERCIAL)", type: "GOODS" },
      { name: "ARTICULATED VEHICLE", type: "GOODS" },
      { name: "EDUCATIONAL INSTITUTION BUS", type: "PASSENGER" },
    ],
    passengerCategory: [
      { name: "LIGHT PASSENGER VEHICLE" },
      { name: "MEDIUM PASSENGER VEHICLE" },
      { name: "HEAVY PASSENGER VEHICLE" },
    ],
    goodsCategory: [
      { name: "LIGHT GOODS VEHICLE" },
      { name: "MEDIUM GOODS VEHICLE" },
      { name: "HEAVY GOODS VEHICLE" },
    ],
    permitType: [
      { name: "TEMPORARY PERMIT" },
      { name: "CONTRACT CARRIAGE PERMIT" },
      { name: "NATIONAL PERMIT" },
      { name: "PRIVATE SERVICE VEHICLE PERMIT" },
      { name: "NOT APPLICABLE" },
    ],
    serviceType: [
      { name: "ORDINARY" },
      { name: "AIR CONDITIONED" },
      { name: "Goods Service" },
      { name: "NOT APPLICABLE" },
    ],
    taxMode: [
      { name: "DAYS" },
      { name: "WEEKLY" },
      { name: "MONTHLY" },
      { name: "QUARTERLY" },
    ],
  };

  // all input fields
  const [payLoad, setPayLoad] = useState({
    vehicleNo: '',
    chassisNo: '',
    mobileNo: '',
    ownerName: '',
    fromState: '',
    entryDistrictName: '',
    entryCheckPostName: '',
    vehiclePermitType: 'TRANSPORT',
    vehicleClass: '',
    vehicleCategory: '',
    permitType: '',
    seatingCapacityExcludingDriver: '',
    sleeperCap: '0',
    grossVehicleWeight: '',
    unladenWeight: '',
    serviceType: '',
    insuranceValidity: '',
    fitnessValidity: '',
    puccValidity: '',
    grossCombinationWeight: '',
    taxMode: '',
    noOfPeriod: '',
    taxFromDate: '',
    taxUptoDate: '',
    additionalMvTax: '',
    entryFees: '',
    totalAmount: '',
  });

  const [isLoading, setIsLoading] = useState(false);

  const form = useRef(null);

  const getDetailsHandler = async () => {
    if (!payLoad.vehicleNo) {
      alert('Please enter vehicle no.');
      return;
    }
    setIsLoading(true);
    const { data } = await getDetailsApi({
      vehicleNo: payLoad.vehicleNo,
    });
    setIsLoading(false);
    if (data && data.success) {
setPayLoad((e) => ({
        ...e,
        ...mergeLookupDetails(e, data.detail),
      }));
    }
  };

  const onSubmitHandler = async (e) => {
    e.preventDefault();
    history.push('/select-payment', {
      formData: {
        ...payLoad,
        state,
        totalAmount: calculateTotal(),
      },
    });
  };

  const calculateTotal = () => {
    return (+payLoad.additionalMvTax) + (+payLoad.entryFees);
  };

  const onChangeHandler = (e) => {
    const { name, value } = e.target;
    setPayLoad((old) => {
      let updatedData = { ...old, [name]: value };
      if (name === 'entryDistrictName') {
        updatedData.entryCheckPostName = '';
      }
      if (name === 'vehicleClass') {
        updatedData.vehicleCategory = '';
      }
      return updatedData;
    });
  };

  const onResetHandler = () => {
    let p = {};
    Object.keys(payLoad).forEach((e) => {
      p[e] = '';
    });
    setPayLoad({ ...p, sleeperCap: '0', grossVehicleWeight: '', unladenWeight: '', additionalMvTax: '0', entryFees: '0', vehiclePermitType: 'TRANSPORT' });
  };

  if (
    !isLoggedIn ||
    !isLoggedIn.accessState ||
    (!isLoggedIn.accessState.includes(fields.stateName.mizoram) && isLoggedIn.role !== 'admin')
  ) {
    return (
      <>
        <Header />
        <div className='container text-center mt-4 '>
          <h3>No Access of this state</h3>
        </div>
      </>
    );
  }

  const isGoodsVehicle = payLoad.vehicleClass && MIZO_FIELDS.vehicleClass.find(v => v.name === payLoad.vehicleClass)?.type === 'GOODS';

  return (
    <>
      <Header />
      <div className='text-center'>
        <p className='login-heading mt-4'>
          <b>Border Tax Payment for Entry Into</b> <span style={{ color: 'red' }}>MIZORAM</span>
        </p>
      </div>

      <div className='box box--main'>
        <div className='box__heading--blue'>Tax Payment Details</div>
        <form ref={form} onSubmit={onSubmitHandler} className='service-type tax-details mt-4'>
          <div className="row">
            {/* Left Side */}
            <div className="col-6">
              <div className="form__control">
                <label className="form__label d-block w-100 text-left">Vehicle No.<sup>*</sup></label>
                <input
                  tabIndex="1"
                  required
                  maxLength="10"
                  autoFocus
                  disabled={isLoading}
                  value={payLoad.vehicleNo}
                  onChange={onChangeHandler}
                  className="form__input w-100"
                  type="text"
                  name="vehicleNo"
                />
              </div>

              <div className="row">
                <div className="col-sm-6">
                  <div className="form__control">
                    <label className="form__label d-block w-100 text-left">Chassis No.<sup>*</sup></label>
                    <input required name="chassisNo" value={payLoad.chassisNo} onChange={onChangeHandler} className="form__input w-100" type="text" />
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form__control">
                    <label className="form__label d-block w-100 text-left">Mobile No.<sup>*</sup></label>
                    <input required name="mobileNo" value={payLoad.mobileNo} onChange={onChangeHandler} className="form__input w-100" type="text" maxLength="10" />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-6">
                  <div className="form__control">
                    <label className="form__label d-block w-100 text-left">Entry District Name<sup>*</sup></label>
                    <select required name="entryDistrictName" value={payLoad.entryDistrictName} onChange={onChangeHandler} className="form__input w-100">
                      <option value="">--Select District--</option>
                      {MIZO_FIELDS.districtName.map(d => <option key={d.name} value={d.name}>{d.name}</option>)}
                    </select>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form__control">
                    <label className="form__label d-block w-100 text-left">Entry CheckPost Name<sup>*</sup></label>
                    <select required name="entryCheckPostName" value={payLoad.entryCheckPostName} onChange={onChangeHandler} className="form__input w-100">
                      <option value="">--Select Checkpost--</option>
                      {payLoad.entryDistrictName && MIZO_FIELDS.checkPostName.filter(c => c.district === payLoad.entryDistrictName).map(c => (
                        <option key={c.name} value={c.name}>{c.name}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-6">
                  <div className="form__control">
                    <label className="form__label d-block w-100 text-left">Vehicle Type<sup>*</sup></label>
                    <select required name="vehiclePermitType" value={payLoad.vehiclePermitType} onChange={onChangeHandler} className="form__input w-100">
                      {MIZO_FIELDS.vehiclePermitType.map(v => <option key={v.name} value={v.name}>{v.name}</option>)}
                    </select>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form__control">
                    <label className="form__label d-block w-100 text-left">Vehicle Class<sup>*</sup></label>
                    <select required name="vehicleClass" value={payLoad.vehicleClass} onChange={onChangeHandler} className="form__input w-100">
                      <option value="">--Select Vehicle Class--</option>
                      {MIZO_FIELDS.vehicleClass.map(v => <option key={v.name} value={v.name}>{v.name}</option>)}
                    </select>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-6">
                  <div className="form__control">
                    <label className="form__label d-block w-100 text-left">Service Type<sup>*</sup></label>
                    <select required name="serviceType" value={payLoad.serviceType} onChange={onChangeHandler} className="form__input w-100">
                      <option value="">Select Service Type...</option>
                      {MIZO_FIELDS.serviceType.map(s => <option key={s.name} value={s.name}>{s.name}</option>)}
                    </select>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form__control">
                    <label className="form__label d-block w-100 text-left">Gross Combination Weight(in kg.)<sup>*</sup></label>
                    <input required name="grossCombinationWeight" value={payLoad.grossCombinationWeight} onChange={onChangeHandler} className="form__input w-100" type="number" />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-6">
                  <div className="form__control">
                    <label className="form__label d-block w-100 text-left">Tax From<sup>*</sup></label>
                    <input required name="taxFromDate" value={payLoad.taxFromDate} onChange={onChangeHandler} className="form__input w-100" type="datetime-local" />
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form__control">
                    <label className="form__label d-block w-100 text-left">Tax Upto<sup>*</sup></label>
                    <input required name="taxUptoDate" value={payLoad.taxUptoDate} onChange={onChangeHandler} className="form__input w-100" type="datetime-local" />
                  </div>
                </div>
              </div>

              <div className="form__control">
                <label className="form__label d-block w-100 text-left">Tax Mode<sup>*</sup></label>
                <select required name="taxMode" value={payLoad.taxMode} onChange={onChangeHandler} className="form__input w-100">
                  <option value="">Select Tax Mode...</option>
                  {MIZO_FIELDS.taxMode.map(t => <option key={t.name} value={t.name}>{t.name}</option>)}
                </select>
              </div>
            </div>

            {/* Right Side */}
            <div className="col-6">
              <div className="form__control text-left">
                <label className="form__label d-block w-100 text-left">&nbsp;</label>
                <button
                  disabled={isLoading}
                  type="button"
                  onClick={getDetailsHandler}
                  className="box__button get-details"
                >
                  {isLoading ? (
                    <div className="spinner-border spinner-border-sm mr-2" role="status"></div>
                  ) : (
                    <span className="glyphicon glyphicon-arrow-down mr-3"></span>
                  )}
                  Get Details
                </button>
              </div>

              <div className="form__control">
                <label className="form__label d-block w-100 text-left">Owner Name<sup>*</sup></label>
                <input required name="ownerName" value={payLoad.ownerName} onChange={onChangeHandler} className="form__input w-100" type="text" />
              </div>

              <div className="row">
                <div className="col-sm-6">
                  <div className="form__control">
                    <label className="form__label d-block w-100 text-left">From State<sup>*</sup></label>
<select required name="fromState" value={payLoad.fromState} onChange={onChangeHandler} className="form__input w-100">
                      <option value="">--Select State--</option>
                      {fields.fromState.map(s => <option key={s.name} value={String(s.name).toUpperCase()}>{s.name}</option>)}
                    </select>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form__control">
                    <label className="form__label d-block w-100 text-left">No of Period<sup>*</sup></label>
                    <input required name="noOfPeriod" value={payLoad.noOfPeriod} onChange={onChangeHandler} className="form__input w-100" type="number" />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-6">
                  <div className="form__control">
                    <label className="form__label d-block w-100 text-left">Vehicle Category<sup>*</sup></label>
                    <select required name="vehicleCategory" value={payLoad.vehicleCategory} onChange={onChangeHandler} className="form__input w-100">
                      <option value="">--Select Vehicle Category--</option>
                      {payLoad.vehicleClass && (
                        isGoodsVehicle 
                        ? MIZO_FIELDS.goodsCategory.map(c => <option key={c.name} value={c.name}>{c.name}</option>)
                        : MIZO_FIELDS.passengerCategory.map(c => <option key={c.name} value={c.name}>{c.name}</option>)
                      )}
                    </select>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form__control">
                    <label className="form__label d-block w-100 text-left">Permit Type<sup>*</sup></label>
                    <select required name="permitType" value={payLoad.permitType} onChange={onChangeHandler} className="form__input w-100">
                      <option value="">Select Permit Type...</option>
                      {MIZO_FIELDS.permitType.map(p => <option key={p.name} value={p.name}>{p.name}</option>)}
                    </select>
                  </div>
                </div>
              </div>

              {isGoodsVehicle ? (
                <div className="row">
                  <div className="col-sm-6">
                    <div className="form__control">
                      <label className="form__label d-block w-100 text-left">Gross Vehicle Wt.(in kg)<sup>*</sup></label>
                      <input required name="grossVehicleWeight" value={payLoad.grossVehicleWeight} onChange={onChangeHandler} className="form__input w-100" type="number" />
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form__control">
                      <label className="form__label d-block w-100 text-left">Unladen Wt.(in kg)<sup>*</sup></label>
                      <input required name="unladenWeight" value={payLoad.unladenWeight} onChange={onChangeHandler} className="form__input w-100" type="number" />
                    </div>
                  </div>
                </div>
              ) : (
                <div className="row">
                  <div className="col-sm-6">
                    <div className="form__control">
                      <label className="form__label d-block w-100 text-left">Seating Capacity<sup>*</sup></label>
                      <input required name="seatingCapacityExcludingDriver" value={payLoad.seatingCapacityExcludingDriver} onChange={onChangeHandler} className="form__input w-100" type="number" />
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form__control">
                      <label className="form__label d-block w-100 text-left">Sleeper Capacity<sup>*</sup></label>
                      <input required name="sleeperCap" value={payLoad.sleeperCap} onChange={onChangeHandler} className="form__input w-100" type="number" />
                    </div>
                  </div>
                </div>
              )}

              <div className="row">
                <div className="col-sm-6">
                  <div className="form__control">
                    <label className="form__label d-block w-100 text-left">Insurance Validity<sup>*</sup></label>
                    <input required name="insuranceValidity" value={payLoad.insuranceValidity} onChange={onChangeHandler} className="form__input w-100" type="date" />
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form__control">
                    <label className="form__label d-block w-100 text-left">Fitness Validity<sup>*</sup></label>
                    <input required name="fitnessValidity" value={payLoad.fitnessValidity} onChange={onChangeHandler} className="form__input w-100" type="date" />
                  </div>
                </div>
              </div>

              <div className="form__control">
                <label className="form__label d-block w-100 text-left">PUCC Validity<sup>*</sup></label>
                <input required name="puccValidity" value={payLoad.puccValidity} onChange={onChangeHandler} className="form__input w-100" type="date" />
              </div>
            </div>
          </div>

          {/* Tax Table */}
          <div className='row mt-3'>
            <div className='col-12'>
              <table className='hr-table'>
                <thead>
                  <tr>
                    <th className='hr-table-1'>SI. No.</th>
                    <th className='hr-table-2'>Particulars</th>
                    <th>Tax From</th>
                    <th>Tax Upto</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>Additional MV Tax</td>
                    <td>{payLoad.taxFromDate}</td>
                    <td>{payLoad.taxUptoDate}</td>
                    <td className="input-box">
                      <center>
                        <input name="additionalMvTax" value={payLoad.additionalMvTax} onChange={onChangeHandler} type="number" />
                      </center>
                    </td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>Entry Fees</td>
                    <td>{payLoad.taxFromDate}</td>
                    <td>{payLoad.taxUptoDate}</td>
                    <td className="input-box">
                      <center>
                        <input name="entryFees" value={payLoad.entryFees} onChange={onChangeHandler} type="number" />
                      </center>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <br />
          <div className="row">
            <div className="col-sm-6">
              {/* <!-- Total amount --> */}
              <div className="form__control">
                <label
                  className="form__label d-block w-100 text-left"
                  htmlFor="totalAmount"
                >
                  Total amount<sup>*</sup>
                </label>
                <input
                  required
                  tabIndex="18"
                  min="0"
                  disabled
                  value={calculateTotal()}
                  className="form__input w-100"
                  type="number"
                  id="totalAmount"
                  name="totalAmount"
                />
              </div>
            </div>
            <div className="col-sm-6">
              <label className="form__label d-block w-100 text-left">
                &nbsp;
              </label>
              <ActionButtons
                onReset={onResetHandler}
                isDisabled={isLoading}
              />
            </div>
          </div>
        </form>
      </div>
      <br />
    </>
  );
};

export default Mizoram;
